import TF from "@assets/TF.pdf";

export const siteConfig = {
  name: "Bokningsplanering",
  url: "https://bokningsplanering.com/",
  ogImage: "https://bokningsplanering.com/assets/LUS_LEAF.png",
  description:
    "Planera bokning av diverse lokaler och utrustning inför mottagningen på Linköpings Universitet. Systemet hittar automaiskt krockar mellan fadderiers bokningar för att underlätta planeringen.",
  links: {
    linkedin: "https://www.linkedin.com/in/michelle-krejci",
    github: "https://github.com/michkrej/booking-system",
    portfolio: "https://michellekrejci.com",
    TF_2024: TF,
  },
};

export type SiteConfig = typeof siteConfig;
